import base from "/home/ruri/github/monochrome/images/pause-large.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");